module.exports = __webpack_public_path__ + "assets/img/e387-gq.svg";